import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FreteFaixa } from '../models/frete-faixa';

@Injectable({
  providedIn: 'root'
})
export class FaixaFreteService {
  constructor(private http: HttpClient) { }

  salvar(fretefaixa: FreteFaixa) {
    return this.http.post(globals.apiUrl + '/api/FreteFaixa/Salvar', fretefaixa);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/FreteFaixa/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  consultarPorIdFreteFaixa(idFreteFaixa) {
    return this.http.get<any>(globals.apiUrl + '/api/FreteFaixa/Buscar',
      { params: new HttpParams().set('id', idFreteFaixa) });
  }

  consultarFaixas() {
    return this.http.get<FreteFaixa[]>(globals.apiUrl + '/api/FreteFaixa/Lista');
  }

  consultarUltimaFaixa() {
    return this.http.get<FreteFaixa>(globals.apiUrl + '/api/FreteFaixa/BuscarUltimaFaixa');
  }

  consultarComPaginacao(descri, paginaAtual, qtdRegistros, campoOrdenacao, asc_desc) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', asc_desc)
      .set('descri', descri ? descri : '');

    return this.http.get<any>(globals.apiUrl + '/api/FreteFaixa/ListaPag',
      {
        params: parametros
      });
  }
}
